import React from 'react';
import { Form } from 'react-bootstrap';

const InstallmentsDropdown = ({ value, onChange, label = "Cuotas sin interés" }) => {
  const installmentOptions = [
    { value: null, label: "Sin cuotas sin interés" },
    { value: 3, label: "3 cuotas sin interés" },
    { value: 6, label: "6 cuotas sin interés" },
    { value: 12, label: "12 cuotas sin interés" },
  ];
  return (
    <Form.Group className='mb-3' controlId='fixInstallmentsOffer'>
      <Form.Label>{label}</Form.Label>
      <Form.Control
        as='select'
        name='fixInstallmentsOffer'
        value={value || ''}
        onChange={onChange}
      >
        {installmentOptions.map((option, index) => (
          <option key={index} value={option.value === null ? '' : option.value}>
            {option.label}
          </option>
        ))}
      </Form.Control>
    </Form.Group>
  );
};
export default InstallmentsDropdown;